import React, { useEffect, useState } from "react";
import axios from "axios";
import parse from "html-react-parser";
import { Spin, Image, Tag } from "antd";
import { useMessages } from "../api/conversations";
import moment from "moment";

const Conversation = (props) => {
  const { convData, token, conversationRef, messages, setMessages } = props;
  // const conversationRef = useRef();
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(false);
  const { data, isFetched } = useMessages(convData?.id, token, page);

  useEffect(() => {
    isFetched && setMessages(data?.data.messages.data);
    isFetched && setHasMore(true);
  }, [isFetched, data, setMessages]); // console.log('messages ===> ', data?.pages[0].messages.data);
  // console.log("messages", messages);
  const reversed = messages && [...messages].reverse();

  const dateToYMD = (date) => {
    const d = date.getDate();
    const m = date.getMonth() + 1; // Month from 0 to 11
    const y = date.getFullYear();
    return "" + (d <= 9 ? "0" + d : d) + "-" + (m <= 9 ? "0" + m : m) + "-" + y;
  };

  const renderDate = (time) => {
    const date = new Date(time);
    const today = new Date();
    const dateFormated = moment(date).format("yyy-MM-DD");
    const todayFormated = moment(today).format("yyy-MM-DD");
    return (
      <div className="DateContainer" key={time}>
        <span>
          {" "}
          {dateFormated === todayFormated ? "Today" : dateToYMD(date)}{" "}
        </span>
      </div>
    );
  };

  const showDate = (index, item) => {
    const currentCreatedAt = new Date(item?.created_at);
    const currentCreatedAtDate = dateToYMD(currentCreatedAt);

    const nextCreatedAt = new Date(reversed[index - 1]?.created_at);
    const nextCreatedAtDate = dateToYMD(nextCreatedAt);

    return currentCreatedAtDate !== nextCreatedAtDate || !index;
  };

  const stringToHTML = (text) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(text, "text/html");
    return <React.Fragment>{parse(doc.body.innerHTML)}</React.Fragment>;
  };

  useEffect(() => {
    const chatScrollToBottom = () => {
      const scroll = document.getElementById("ConversationContainerScroll");
      page > 1
        ? (scroll.scrollTop = 600)
        : (scroll.scrollTop = scroll.scrollHeight);
      page > 1
        ? scroll.animate({ scrollTop: 600 })
        : scroll.animate({ scrollTop: scroll.scrollHeight });
    };

    chatScrollToBottom();
  }, [messages, page]);

  useEffect(() => {
    page > 1 &&
      axios
        .get(
          `/api/agent/messages/conversations/${convData.id}/messages?page=${page}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              Accept: "application/json",
              "Content-Type": "application/json",
            },
          }
        )
        .then((res) => {
          console.log("res ==> ", res);
          setMessages((prev) => [...prev, ...res.data.messages.data]);
          setHasMore(page < res.data.messages.last_page);
        })
        .catch((error) => {
          console.log(error);
        });
  }, [page, convData?.id, token, setMessages]);

  const onScroll = () => {
    if (conversationRef.current) {
      const { scrollTop } = conversationRef.current;
      if (scrollTop < 100) {
        if (hasMore) {
          setPage((prevPage) => prevPage + 1);
          setHasMore(false);
        }
      }
    }
  };
  const isLastObjectWithValueOne = (array, target) => {
    let foundLastObjectWithValueOne = false;
    for (let i = array.length - 1; i >= 0; i--) {
      const obj = array[i];
      if (obj.is_gifting === 1) {
        if (!foundLastObjectWithValueOne) {
          foundLastObjectWithValueOne = true;
          if (obj === target) {
            return true;
          }
        }
      }
    }
    return false;
  };

  return (
    <div
      className="ConversationContainer"
      id="ConversationContainerScroll"
      ref={conversationRef}
      onScroll={onScroll}
    >
      {data ? (
        reversed?.map((message, index) => {
          const time = message?.created_at;
          return (
            <React.Fragment key={message.id}>
              {showDate(index, message) && renderDate(time)}
              <div
                key={message.id}
                className={
                  message.is_gifting
                    ? `gift-message  ${
                        isLastObjectWithValueOne(reversed, message) && "flash"
                      }`
                    : message.sender_profile_id ===
                      convData.fictitious_profile.id
                    ? "MessageContainer SentMessage"
                    : "MessageContainer ReceivedMessage"
                }
              >
                <div className="Message">
                  <div className="ImageContainer">
                    {message?.attachments !== null &&
                      message?.attachments.length > 0 && (
                        <Image width={200} src={message.attachments[0]} />
                      )}
                  </div>
                  <div
                    className={
                      !message.is_gifting ? "TextContainer" : `gift-text`
                    }
                  >
                    {stringToHTML(message.body)}
                    {message.is_gifting &&
                    isLastObjectWithValueOne(reversed, message) ? (
                      <span>
                        <br />
                        say thank you!
                      </span>
                    ) : null}
                  </div>
                </div>
                <div className={"bubble-footer"}>
                  {message.sender_profile_id ===
                    convData.fictitious_profile.id && (
                    <Tag color="magenta">
                      Agent: <span>{message.agent_username ?? "System"}</span>
                    </Tag>
                  )}
                  <div className="Time">{moment(time).format("HH:mm")}</div>
                </div>
              </div>
            </React.Fragment>
          );
        })
      ) : (
        <div className="LoaderContainer">
          {convData ? <Spin tip="Loading messages" /> : "No Data"}
        </div>
      )}
    </div>
  );
};

export default Conversation;
